module.exports = __webpack_public_path__ + "static/media/Noise Pollution.b901801d.svg";